import { createSlice } from "@reduxjs/toolkit";

export const userClientSlice = createSlice({
  name: "userClient",
  initialState: {
    adBlocking: false,
    fullScreenActive: false,
    isABTestLocalStorageCleaned: false,
  },
  reducers: {
    setAdBlocking: (prevState, action) => {
      const state = prevState;
      state.adBlocking = action.payload.adBlocking;
    },
    toggleFullScreenActive: (prevState) => {
      const state = prevState;
      state.fullScreenActive = !state.fullScreenActive;
    },
    setFullScreenActive: (prevState, action) => {
      const state = prevState;
      state.fullScreenActive = action.payload.fullScreenActive;
    },
    setABTestLocalStorageCleaned: (prevState, action) => {
      const state = prevState;
      state.isABTestLocalStorageCleaned = action.payload.isABTestLocalStorageCleaned;
    },
  },
  selectors: {
    adBlockingSelector: (state) => state.adBlocking,
    fullScreenActiveSelector: (state) => state.fullScreenActive,
    isABTestLocalStorageCleanedSelector: (state) => state.isABTestLocalStorageCleaned,
  },
});

export const { setAdBlocking, toggleFullScreenActive, setFullScreenActive, setABTestLocalStorageCleaned } =
  userClientSlice.actions;
export const { adBlockingSelector, fullScreenActiveSelector, isABTestLocalStorageCleanedSelector } =
  userClientSlice.selectors;

export default userClientSlice.reducer;
